import { render } from "./OpportunitySelect.vue?vue&type=template&id=21013b54&scoped=true"
import script from "./OpportunitySelect.vue?vue&type=script&lang=js"
export * from "./OpportunitySelect.vue?vue&type=script&lang=js"

import "./OpportunitySelect.vue?vue&type=style&index=0&id=21013b54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21013b54"],['__file',"src/components/h5/partner/OpportunitySelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21013b54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21013b54', __exports__)) {
    api.reload('21013b54', __exports__)
  }
  
  module.hot.accept("./OpportunitySelect.vue?vue&type=template&id=21013b54&scoped=true", () => {
    api.rerender('21013b54', render)
  })

}


export default __exports__